/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {
    var desktopMegaMenuLink = document.querySelector('.nav-bar__linklist > li.nav-bar__item:nth-child(3) > .mega-menu .mega-menu__column:nth-child(3) > ul.mega-menu__linklist:nth-child(2)');
    var featCanvasLabHtml = '<div id="feat_canvaslab"><a href="/collections/kits-de-collage"><img loading="lazy" src="https://cdn.shopify.com/s/files/1/0258/6276/6677/files/Kits-de-collage---homepage.png?v=1683672132"><div>Conoce nuestros Kits de Collage</div></a></div>';
    if (desktopMegaMenuLink) desktopMegaMenuLink.insertAdjacentHTML('beforebegin', featCanvasLabHtml);

    var mobileNavMenuLink = document.querySelector('.mobile-menu__section:nth-child(1) > ul.mobile-menu__nav > li.mobile-menu__nav-item:nth-last-child(1)');
    if (mobileNavMenuLink) mobileNavMenuLink.insertAdjacentHTML('afterend', featCanvasLabHtml);
});

function initMaterialsExplainer() {
    var dynamicSection = document.getElementById('product-materials-explainer-dynamic');
    var staticSection = document.getElementById('product-materials-explainer');
    
    var productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    var staticLink = productForm.querySelector('.static-materials-trigger');
    var dynamicLinkPrimary = productForm.querySelector('.dynamic-materials-trigger-link');

    // Reset displays first (useful for theme editor reloads)
    if (staticLink) staticLink.style.setProperty('display', 'none', 'important');
    if (dynamicLinkPrimary) dynamicLinkPrimary.style.setProperty('display', 'none', 'important');

    // 1. Determine which section is active and show appropriate link
    if (dynamicSection) {
        if (dynamicLinkPrimary) {
            dynamicLinkPrimary.style.display = 'inline-block';
        } else {
            // Show secondary dynamic link if primary is not available (no material selector)
            var dynamicLinkSecondary = productForm.querySelector('.dynamic-materials-trigger-link-secondary');
            if (dynamicLinkSecondary) {
                dynamicLinkSecondary.style.display = 'block';
            }
        }
    } else if (staticSection) {
        if (staticLink) {
            staticLink.style.display = 'inline-block';
        }
    }
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', initMaterialsExplainer);
// Initialize on Shopify Theme Editor section load
document.addEventListener('shopify:section:load', initMaterialsExplainer);

// Global click listener for smooth scrolling (event delegation)
document.addEventListener('click', function(e) {
    var link = e.target.closest('.static-materials-trigger, .dynamic-materials-trigger-link, .dynamic-materials-trigger-link-secondary, .materials-trigger-link');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) return;

    var targetId = href.substring(1);
    var target = document.getElementById(targetId) || document.querySelector(href);
    
    if (target) {
        e.preventDefault();
        e.stopPropagation(); // Stop theme.js from intercepting this link

        var header = document.getElementById('shopify-section-header');
        var headerHeight = header ? header.getBoundingClientRect().height : 0;
        if (headerHeight < 50) headerHeight = 100;
        
        var announcement = document.getElementById('shopify-section-announcement-bar');
        if (announcement) headerHeight += announcement.getBoundingClientRect().height;

        var buffer = 20;
        var totalOffset = headerHeight + buffer;

        var elementPosition = target.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - totalOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
});

// ========================================================
// ========== INICIA: Lógica Global de Modales ============
// ========================================================
document.addEventListener('DOMContentLoaded', function() {
    // Elemento que abrió el modal visible, para devolverle el foco al cerrar
    var lastModalOpener = null;

    function closeModal(modal) {
        modal.classList.remove('is-visible');
        modal.setAttribute('aria-hidden', 'true'); // Accesibilidad
        // Only remove modal-open from body if there are no other visible modals
        if (!document.querySelector('.global-modal.is-visible')) {
            document.body.classList.remove('modal-open');

            // Restaurar el body y la posición del scroll
            var scrollY = document.body.dataset.scrollY;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0'));
            }
        }
        if (lastModalOpener) {
            // preventScroll: el scroll ya se restauró arriba; sin esto, focus()
            // haría scroll extra hacia el trigger y pisaría la posición restaurada
            lastModalOpener.focus({ preventScroll: true });
            lastModalOpener = null;
        }
    }

    document.addEventListener('click', function(event) {
        var target = event.target;

        // Open modal
        var openBtn = target.closest('[data-modal-target]');
        if (openBtn) {
            event.preventDefault();
            var modalId = openBtn.getAttribute('data-modal-target');
            var modal = document.getElementById(modalId);
            if (modal) {
                // Mover el modal al final del body para escapar de cualquier contexto de apilamiento (stacking context)
                // o propiedades como 'transform' que rompen el 'position: fixed'
                if (modal.parentElement !== document.body) {
                    document.body.appendChild(modal);
                }

                // Guardar la posición de scroll actual y fijar el body
                // Esto previene que el fondo se mueva (overscroll) sin hacer que la página salte al inicio
                if (!document.body.classList.contains('modal-open')) {
                    var scrollY = window.scrollY;
                    document.body.style.position = 'fixed';
                    document.body.style.top = '-' + scrollY + 'px';
                    document.body.style.width = '100%';
                    document.body.dataset.scrollY = scrollY;
                }

                modal.classList.add('is-visible');
                modal.setAttribute('aria-hidden', 'false'); // Accesibilidad
                document.body.classList.add('modal-open');

                lastModalOpener = openBtn;
                var closeButton = modal.querySelector('.global-modal__close');
                if (closeButton) {
                    closeButton.focus();
                }
            }
        }

        // Close modal
        var closeBtn = target.closest('[data-modal-close]');
        if (closeBtn) {
            event.preventDefault();
            var modal = closeBtn.closest('.global-modal');
            if (modal) {
                // Blur the button so it loses focus before we hide the modal
                if (document.activeElement) {
                    document.activeElement.blur();
                }
                closeModal(modal);
            }
        }
    });

    // Accesibilidad (#218): ESC cierra el modal visible y Tab queda atrapado dentro de él
    document.addEventListener('keydown', function(event) {
        var modal = document.querySelector('.global-modal.is-visible');
        if (!modal) return;

        if (event.key === 'Escape' || event.key === 'Esc') {
            event.preventDefault();
            closeModal(modal);
            return;
        }

        if (event.key === 'Tab') {
            var focusables = modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
            if (!focusables.length) return;
            var first = focusables[0];
            var last = focusables[focusables.length - 1];
            if (!modal.contains(document.activeElement)) {
                event.preventDefault();
                first.focus();
            } else if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
    });
});
// ========================================================
// ========== TERMINA: Lógica Global de Modales ===========
// ========================================================

// ========================================================
// ====== Descripción colapsable (snippet collapsible-description, #327) ======
// El truncado se resuelve en Liquid; aquí solo se alterna el estado.
// Delegado para sobrevivir a re-renders (paginación AJAX de colección).
// ========================================================
document.addEventListener('click', function (event) {
  var toggle = event.target.closest('.collapsible-description__toggle');
  if (!toggle) return;
  var container = toggle.closest('[data-collapsible-description]');
  if (!container) return;
  var expanded = container.classList.toggle('is-expanded');
  toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
});
